// src/components/Common/Footer.js

import React from 'react';
import {
  ShieldCheckIcon,
  ChatBubbleLeftRightIcon,
  ShieldExclamationIcon,
  EnvelopeIcon,
  PaperAirplaneIcon,
} from '@heroicons/react/24/solid'; // Importing Heroicons v2

export default function Footer() {
  return (
    <footer className="py-8 px-4 bg-secondary text-gray-300 text-sm w-full">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Left Section: Disclaimer */}
        <div className="flex flex-col space-y-4 text-left">
          <div className="flex items-center space-x-2">
            <ShieldCheckIcon className="h-6 w-6 text-accentOrange" />
            <h2 className="text-lg font-semibold text-accentOrange tracking-wider">
              Disclaimer
            </h2>
          </div>
          <p className="leading-relaxed">
            MF does not host any files. It pulls streams and downloads from third-party services.
            Legal issues should be addressed to the file hosts and providers. MF is not responsible
            for any media files shown by the providers.
          </p>
        </div>

        {/* Middle Section: Contact & Opinions */}
        <div className="flex flex-col space-y-4 text-center">
          <div className="flex items-center justify-center space-x-2">
            <ChatBubbleLeftRightIcon className="h-6 w-6 text-accentBlue" />
            <h2 className="text-lg font-semibold text-accentBlue tracking-wider">
              Contact & Opinions
            </h2>
          </div>
          <p className="leading-relaxed">
            Have feedback or need to reach us?<br />
            We're available through the following:
          </p>
          <div className="flex justify-center space-x-4">
            <a
              href="mailto:mf.moviefinder2025@gmail.com"
              className="flex items-center space-x-1 hover:text-accentOrange transition"
            >
              <EnvelopeIcon className="h-5 w-5" />
              <span>Gmail</span>
            </a>
            <a
              href="https://t.me/mf_moviefinder"
              className="flex items-center space-x-1 hover:text-accentOrange transition"
            >
              <PaperAirplaneIcon className="h-5 w-5" />
              <span>Telegram</span>
            </a>
          </div>
        </div>

        {/* Right Section: DMCA Notice */}
        <div className="flex flex-col space-y-4 text-right">
          <div className="flex items-center justify-end space-x-2">
            <ShieldExclamationIcon className="h-6 w-6 text-accentOrange" />
            <h2 className="text-lg font-semibold text-accentOrange tracking-wider">
              DMCA Notice
            </h2>
          </div>
          <p className="leading-relaxed">
            If you believe your copyrighted work has been used improperly,<br />
            please send a detailed DMCA notice to our email. Include a description of the material, 
            your contact details, and a statement of good faith belief. We’re committed to resolving 
            these matters promptly.
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-8 text-center text-xs text-gray-400">
        &copy; {new Date().getFullYear()} MF Movie Finder. All rights reserved.
      </div>
    </footer>
  );
}
